"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanFlags = exports.SerialParities = exports.Protocols = exports.BAUD_AUTO = exports.MAX_BAUD_RATE = exports.ADAPTER_VOLTAGE_TIMEOUT_MS = exports.ADAPTER_VOLTAGE_SCALE = exports.EscapeXor = exports.EscapeMaskDefault = exports.EscapeCodeDefault = exports.EscapeConfWrite = exports.EscapeConfRead = exports.KWP_KEYBYTE_KWP2000 = exports.FAST_INIT_IDLE_MS = exports.FAST_INIT_BREAK_MS = exports.KWP1281_TIMEOUT = exports.CAN_PROT_ISOTP = exports.CAN_PROT_TP20 = exports.CAN_PROT_BMW = exports.CANF_DISCONNECT = exports.CANF_CONNECT_CHECK = exports.CANF_CAN_ERROR = exports.CANF_NO_ECHO = exports.KLINEF2_KWP1281_DETECT = exports.KLINEF1_USE_KLINE = exports.KLINEF1_FAST_INIT = exports.KLINEF1_NO_ECHO = exports.KLINEF1_SEND_PULSE = exports.KLINEF1_USE_LLINE = exports.KLINEF1_PARITY_SPACE = exports.KLINEF1_PARITY_MARK = exports.KLINEF1_PARITY_ODD = exports.KLINEF1_PARITY_EVEN = exports.KLINEF1_PARITY_NONE = exports.KLINEF1_PARITY_MASK = void 0;
exports.KLINEF1_PARITY_MASK = 0x07;
exports.KLINEF1_PARITY_NONE = 0x00;
exports.KLINEF1_PARITY_EVEN = 0x01;
exports.KLINEF1_PARITY_ODD = 0x02;
exports.KLINEF1_PARITY_MARK = 0x03;
exports.KLINEF1_PARITY_SPACE = 0x04;
exports.KLINEF1_USE_LLINE = 0x08;
exports.KLINEF1_SEND_PULSE = 0x10;
exports.KLINEF1_NO_ECHO = 0x20;
exports.KLINEF1_FAST_INIT = 0x40;
exports.KLINEF1_USE_KLINE = 0x80;
exports.KLINEF2_KWP1281_DETECT = 0x01;
exports.CANF_NO_ECHO = 0x01;
exports.CANF_CAN_ERROR = 0x02;
exports.CANF_CONNECT_CHECK = 0x04;
exports.CANF_DISCONNECT = 0x08;
exports.CAN_PROT_BMW = 0x00;
exports.CAN_PROT_TP20 = 0x01;
exports.CAN_PROT_ISOTP = 0x02;
exports.KWP1281_TIMEOUT = 60;
exports.FAST_INIT_BREAK_MS = 25;
exports.FAST_INIT_IDLE_MS = 25;
exports.KWP_KEYBYTE_KWP2000 = 0x8f;
exports.EscapeConfRead = 0x01;
exports.EscapeConfWrite = 0x02;
exports.EscapeCodeDefault = 0xff;
exports.EscapeMaskDefault = 0x80;
exports.EscapeXor = 0x55;
exports.ADAPTER_VOLTAGE_SCALE = 0.1;
exports.ADAPTER_VOLTAGE_TIMEOUT_MS = 10000;
exports.MAX_BAUD_RATE = 25000;
exports.BAUD_AUTO = 2;
exports.Protocols = {
    Uart: "uart",
    Kwp: "kwp",
    Tp20: "tp20",
    IsoTp: "isotp"
};
exports.SerialParities = {
    None: "none",
    Odd: "odd",
    Even: "even",
    Mark: "mark",
    Space: "space"
};
exports.CanFlags = {
    Empty: 0x00,
    BusCheck: 0x01,
    Disconnect: 0x02
};
//# sourceMappingURL=constants.js.map